import React, { createContext, ReactNode, useContext } from "react";

import { IDevelopmentMediaLinkService } from "../types/services/development-media-link-service";

const DevelopmentMediaLinkServiceContext = createContext<
  IDevelopmentMediaLinkService
>(undefined as any);

interface DevelopmentMediaLinkServiceProviderProps {
  children: ReactNode;
  service: IDevelopmentMediaLinkService;
}

function DevelopmentMediaLinkServiceProvider(
  props: DevelopmentMediaLinkServiceProviderProps,
) {
  const { children, service } = props;

  return (
    <DevelopmentMediaLinkServiceContext.Provider value={service}>
      {children}
    </DevelopmentMediaLinkServiceContext.Provider>
  );
}

function useDevelopmentMediaLinkService() {
  return useContext(DevelopmentMediaLinkServiceContext);
}

export { DevelopmentMediaLinkServiceProvider, useDevelopmentMediaLinkService };
